<template>
    <span :style="'color:'+stateColor()">{{OrderStateCaption[state]}}</span>
</template>

<script>
const OrderState = {
    Normal: 1,
    Canceled: 9
};
const OrderStateCaption = {
    1: '正常',
    9: '已作废'
}
export default {
    name: "OrderStateRender",
    props: {
        state: Number|String
    },
    data()
    {
        return {
            OrderState: OrderState,
            OrderStateCaption: OrderStateCaption,
            colors: {
                [OrderState.Normal]: '#0099FF',
                [OrderState.Canceled]: '#FF6600',
            }
        }
    },
    methods: {
        stateColor()
        {
            return this.colors[this.state]? this.colors[this.state]: 'gray';
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/erp/components/render/OrderStateRender.vue